import Icon from '../components/Icon.jsx';
import './OpeningSlide.css';
import coverHearingExam from '../assets/cover-hearing-exam-overlay.png';

const milestones = [
  { id: '01', title: 'Enhancing Patient Access', className: 'milestone-access' },
  { id: '02', title: 'Expanding Rehabilitation', className: 'milestone-rehab' },
  { id: '03', title: 'Driving Community Impact', className: 'milestone-impact' },
  { id: '04', title: 'Supporting Sustainable Growth', className: 'milestone-growth' },
];

const soundBars = [16, 26, 38, 50, 58, 50, 38, 26, 16];

export default function OpeningSlide() {
  return (
    <section className="slide-content cover-v4">
      <div className="cover-v4-field" aria-hidden="true">
        <div className="cover-v4-photo" style={{ backgroundImage: `url(${coverHearingExam})` }} />
        <div className="cover-v4-grid" />
        <div className="cover-v4-glow cover-v4-glow-a" />
        <div className="cover-v4-glow cover-v4-glow-b" />

        <svg
          className="cover-v4-wave-system"
          viewBox="0 0 1600 900"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="coverV4Primary" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0" stopColor="#8fb6d8" stopOpacity="0.08" />
              <stop offset="0.26" stopColor="#8fb6d8" stopOpacity="0.46" />
              <stop offset="0.64" stopColor="#1a95d3" stopOpacity="0.96" />
              <stop offset="1" stopColor="#b7a996" stopOpacity="0.86" />
            </linearGradient>
            <linearGradient id="coverV4Secondary" x1="1" y1="0" x2="0" y2="0">
              <stop offset="0" stopColor="#cfe3f1" stopOpacity="0.05" />
              <stop offset="0.52" stopColor="#cfe3f1" stopOpacity="0.42" />
              <stop offset="1" stopColor="#ffffff" stopOpacity="0.08" />
            </linearGradient>
            <filter id="coverV4Glow" x="-30%" y="-30%" width="160%" height="160%">
              <feGaussianBlur stdDeviation="12" result="blur" />
              <feMerge>
                <feMergeNode in="blur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
            <path
              id="coverV4MotionPath"
              d="M-80 545 C40 545 70 420 165 545 S305 670 410 545 S575 385 705 545 S900 685 1035 545 S1210 405 1340 545 S1490 620 1680 470"
            />
          </defs>

          <g className="cover-v4-wave-group">
            <path
              className="cover-v4-wave-halo"
              d="M-80 545 C40 545 70 420 165 545 S305 670 410 545 S575 385 705 545 S900 685 1035 545 S1210 405 1340 545 S1490 620 1680 470"
            />
            <path
              className="cover-v4-wave-main"
              d="M-80 545 C40 545 70 420 165 545 S305 670 410 545 S575 385 705 545 S900 685 1035 545 S1210 405 1340 545 S1490 620 1680 470"
            />
            <path
              className="cover-v4-wave-echo"
              d="M-80 505 C55 505 80 450 175 505 S320 575 420 505 S585 430 710 505 S895 590 1030 505 S1210 445 1340 505 S1510 565 1680 505"
            />
            <path
              className="cover-v4-wave-secondary"
              d="M-90 615 C55 615 95 525 205 615 S360 705 485 615 S675 510 820 615 S1015 720 1160 615 S1340 525 1470 615 S1585 650 1690 610"
            />
            <path
              className="cover-v4-wave-thread"
              d="M-40 568 C170 530 330 600 525 548 C745 490 925 566 1115 548 C1310 530 1445 480 1640 390"
            />
          </g>

          <g className="cover-v4-signal-particles" filter="url(#coverV4Glow)">
            <circle r="6">
              <animateMotion dur="8s" repeatCount="indefinite" begin="-1s">
                <mpath href="#coverV4MotionPath" />
              </animateMotion>
            </circle>
            <circle r="4">
              <animateMotion dur="11s" repeatCount="indefinite" begin="-5s">
                <mpath href="#coverV4MotionPath" />
              </animateMotion>
            </circle>
            <circle r="3">
              <animateMotion dur="14s" repeatCount="indefinite" begin="-8s">
                <mpath href="#coverV4MotionPath" />
              </animateMotion>
            </circle>
          </g>
        </svg>

        <div className="cover-v4-scanline" />
      </div>

      <div className="cover-v4-copy reveal-stack">
        <div className="eyebrow">
          <Icon name="wave" />
          Service
        </div>

        <h1>
          <span>FROM DETECTION</span>
          <span>TO LIFELONG</span>
          <em>HEARING CARE</em>
        </h1>

        <p className="cover-v4-lead">
          Enhancing Patient Access • Expanding Rehabilitation<br />
          • Driving Community Impact • Supporting<br />
          Sustainable Growth
        </p>

        <div className="cover-v4-label">
          <i />
          <span>Strategic Audiology</span>
          <b>Services Expansion</b>
        </div>
      </div>

      <div className="cover-v4-pathway" aria-label="Clinical pathway milestones">
        <div className="cover-v4-audio-node">
          <div className="cover-v4-audio-bars" aria-hidden="true">
            {soundBars.map((height, index) => (
              <i
                key={`${height}-${index}`}
                style={{ '--bar-index': index, '--bar-height': `${height}px` }}
              />
            ))}
          </div>
          <span>Clinical</span>
          <b>Pathway</b>
          <div className="cover-v4-pulse cover-v4-pulse-a" />
          <div className="cover-v4-pulse cover-v4-pulse-b" />
        </div>

        {milestones.map((milestone) => (
          <div className={`cover-v4-milestone ${milestone.className}`} key={milestone.id}>
            <span>{milestone.id}</span>
            <b>{milestone.title}</b>
            <i />
          </div>
        ))}
      </div>

      <div className="cover-v4-footer" aria-hidden="true">
        {milestones.map((milestone) => (
          <span key={milestone.id}>
            <b>{milestone.id}</b>
            {milestone.title
              .replace('Enhancing ', '')
              .replace('Expanding ', '')
              .replace('Driving ', '')
              .replace('Supporting ', '')}
          </span>
        ))}
      </div>
    </section>
  );
}
